var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAmex = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    viewBox: "0 0 64 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint0_radial)",
    fillRule: "evenodd",
    d: "M0 6c0-3.314 2.686-6 6-6h52c3.314 0 6 2.686 6 6v30c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1793C0",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    d: "M14.657 22.021l1.334-3.303h.028l1.29 3.303h-2.652zm.215-5.521L11 25.5h2.266l.803-2.004h3.829l.774 2.004h2.338l-3.83-9h-2.308zm7.027 0v9h2.108v-6.315h.029l2.51 6.315h1.735l2.51-6.378h.028V25.5h2.108v-9h-3.17l-2.265 6.19h-.029l-2.395-6.19h-3.17zm13.007 0v9h7.773v-1.664h-5.522V21.63h4.962v-1.538h-4.962v-1.928h5.407V16.5h-7.658zm11.802 4.286l-3.57 4.714h2.523l2.28-3.113L50.18 25.5h2.681l-3.57-4.702 3.284-4.298h-2.467l-2.08 2.874L46.02 16.5h-2.61l3.298 4.286z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 25.5h2.266l.803-2.004h3.829l.774 2.004h2.338l-3.83-9h-2.308L11 25.5zm3.657-3.479l1.334-3.303h.028l1.291 3.303h-2.653zm5.242-4.24L18.503 14.5h-4.948l-5.593 13h6.657l.803-2.004h1.105L17.3 27.5h29.375l1.25-1.707 1.227 1.707h7.738l-5.087-6.698 4.815-6.302h-7.533l-1.03 1.422-.993-1.422H28.36l-.934 2.551-.987-2.551h-6.54v3.28zm2 7.719h2.108v-6.315h.029l2.51 6.315h1.735l2.51-6.378h.028V25.5h2.108v-9h-3.17l-2.265 6.19h-.029l-2.395-6.19H21.9v9zm13.007-9v9h7.773v-1.664h-5.522V21.63h4.962v-1.538h-4.962v-1.928h5.407V16.5h-7.658zm11.802 4.286l-3.57 4.714h2.523l2.28-3.113L50.18 25.5h2.681l-3.57-4.702 3.284-4.298h-2.467l-2.08 2.874L46.02 16.5h-2.61l3.298 4.286zm-2.589.105l.073-.096-.073-.094v.19z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 42 -64 0 21.492 7.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BD"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAmex, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AMEX.b8d23a75.svg";
export { ForwardRef as ReactComponent };